import { render, staticRenderFns } from "./proprietarioFrota.vue?vue&type=template&id=e28ed6b6&scoped=true"
import script from "./proprietarioFrota.vue?vue&type=script&lang=js"
export * from "./proprietarioFrota.vue?vue&type=script&lang=js"
import style0 from "./proprietarioFrota.vue?vue&type=style&index=0&id=e28ed6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28ed6b6",
  null
  
)

export default component.exports